<div class="remindersCalendarList">
  <h3 class="remindersCalendarList__title">{{ 'calendar_list_results' | ppTranslate }}</h3>

  <cdk-virtual-scroll-viewport
    #scrollContainer
    itemSize="30"
    class="remindersCalendarList__viewport"
    role="list"
    aria-label="Reminders list"
    >
    <ng-container
      *cdkVirtualFor="let reminder of reminders; let i = index; trackBy: trackByReminderId"
      >
      @if (i === todayIndex) {
        <ng-container class="remindersCalendarList__textSeperator">
          <p class="remindersCalendarList__textSeperator">
            {{ 'today_onwards' | ppTranslate }}
          </p>
        </ng-container>
      }

      <div class="remindersCalendarList__reminder" role="article" [attr.aria-label]="'Reminder: ' + reminder.name">
        <pp-reminder-calendar-element
          [ppReminder]="reminder"
          [ppListView]="true"
          [ppDailyView]="false"
        ></pp-reminder-calendar-element>
      </div>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
